import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Term, TranslateDirective } from '@speedy/core';

@Component({
  selector: 'app-autocomplete-terms',
  templateUrl: './autocomplete-terms.component.html',
  styleUrls: ['./autocomplete-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective],
  standalone: true,
})
export class AutocompleteTermsComponent {
  @Input() searchTerms!: Term[];
}
